import {useEffect, useState, useRef, forwardRef} from 'react';
import SimpleBar from 'simplebar-react';

// Components
import Loading from '../components/helper/loading';
import { Halo } from '../globalValues';
import Popup from '../components/popup';

// Images
import { VirtuosoGrid, VirtuosoGridHandle } from 'react-virtuoso';
import getHaloWallpapers from '../api/getHalo';


interface Preview {
  name: string,
  thumbnail: string,
  url: string
}

export default function HaloInfinite() {

  const [scrollParent, setScrollParent] = useState<any>(null);
  const virtuosoRef = useRef<VirtuosoGridHandle>(null);
  const [loading, setLoading] = useState(true);

  const [wallpaperList, setWallpaperList] = useState<Halo[]>([]);
  const [sortedList, setSortedList] = useState<Halo[]>([]);

  const [filterType, setFilterType] = useState(0);

  // Popup
  const [isOpen, setIsOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState<Preview>({name: "", url: "", thumbnail: ""});

  
  async function getWallpapers() {
    try{
      setLoading(true);
      const res: Halo[] | undefined = await getHaloWallpapers();

      setWallpaperList(res!);    
      setSortedList(res!);
      setLoading(false);
    }
    catch(e) {
      console.log(e)
    }    
  };

  function displayFullImage(name: string, thumbnail: string, url: string) {
    setIsOpen(true); 
    setPreviewImage({name: name, thumbnail: thumbnail, url: url}); 

    let ex = document.getElementById("html");
    ex?.classList.add("overflow-y-hidden");     
  }

  function closePreview() {
    setIsOpen(false); 
    setPreviewImage({name: "", thumbnail: "", url: ""}); 

    let ex = document.getElementById("html");
    ex?.classList.remove("overflow-y-hidden");
  }
  
  useEffect(() => {
    getWallpapers();
    if(wallpaperList.length === 0) {
      const storedList = JSON.parse(window.sessionStorage.getItem("listofWallpapers-Halo")!);
      if(storedList === null || storedList.length === 0) {
        getWallpapers();
      }
      else {
        const lastFetch = JSON.parse(localStorage.getItem("Last-Fetch-Time-Halo")!);
        const d = new Date();
        const currentTime = d.getTime();
        if(currentTime - lastFetch >= 3600000 || lastFetch === null) {
          console.log("Has been longer than 1 hour, get a new fetch");
          getWallpapers();
        }
        else {
          setWallpaperList(storedList);
          setSortedList(storedList);
          setLoading(false);
        }
      }
    }
  }, []);

  useEffect(() => {
    // Sort by season
    if((filterType === 0)) {
      setSortedList( wallpaperList.sort(function(a, b) { 
        var textA = parseInt(a.season);
        var textB = parseInt(b.season);
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      }));
    }
    // Sort by alphabetical
    else if((filterType === 1)) {
      setSortedList(wallpaperList.sort(function(a, b) { 
        var textA = a.id;
        var textB = b.id;
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      }));
    }
  }, [filterType]);



 
  if(loading) {
    return (
      <>
        <Loading />
      </>
    );
  }
  else {
    return (
      <SimpleBar forceVisible="y" autoHide={false} ref={setScrollParent} clickOnTrack={false}>
        {isOpen === true && 
          <Popup 
            type={"halo"}
            name={previewImage.name}
            thumbnail={previewImage.thumbnail}
            url={previewImage.url}
            closePreview={closePreview}
          />
        }

        <h3 style={{marginLeft: '15px', paddingTop: '60px'}}>Halo Infinite Wallpapers</h3>

        <div className="radio-form"> 

          <div className="radio">
            <input
              id="radio-1"
              name="radio"
              type="radio"
              checked={filterType === 0}
              value={0}
              onClick={() => { setFilterType(0) }} 
            />
            <label htmlFor="radio-1" className="radio-label bold">Seasons</label>
          </div>

          <div className="radio">
            <input
              id="radio-2"
              name="radio"
              type="radio"
              checked={filterType === 1}
              value={1}
              onClick={() => { setFilterType(1) }} 
            />
            <label htmlFor="radio-2" className="radio-label">A - Z</label>
          </div>

          <a href="https://drive.google.com/drive/folders/1S0rOivCi7yms8MCglR1bRFdfnaYHjcSh" target="_blank">
            <button className="red font-1">
              Download All
            </button>
          </a>
        </div>          

        <VirtuosoGrid
          totalCount={sortedList.length}
          components={gridComponents}
          increaseViewportBy={{ top: 210, bottom: 420 }}
          ref={virtuosoRef}
          itemContent={(index) =>{
            return(
                <ItemWrapper>
                  <div
                    className="gallery-button"
                    key={"destiny " + index}
                    onClick={() => {
                      displayFullImage(sortedList[index].id , sortedList[index].thumbnail, sortedList[index].url)
                      
                    }}
                  >                    
                    <img src={sortedList[index].thumbnail} alt="" loading='lazy'/>
                  </div>
                </ItemWrapper>
            );                                      
          }}
          customScrollParent={scrollParent ? scrollParent.contentWrapperEl : undefined}
        />
      </SimpleBar>
    );
  }
}


const ItemWrapper = ({ children, ...props }: any) => (
  <div
    {...props}
    className="wallpaper-grid-sub"
  >
    {children}
  </div>
)

// For the Virtual Grid
const gridComponents = {
  List: forwardRef(({ style, children, ...props }: any, ref: any) => (
    <div
      ref={ref}
      {...props}
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        ...style,
      }}
    >
      {children}
    </div>
  )),

  Item: ({ children, ...props }: any) => (
    <div
      {...props}
      className="wallpaper-grid-item"
    >
      {children}
    </div>
  )
}